/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Create_TitleInputs */

const en_settings_tickets_create_title = /** @type {(inputs: Settings_Tickets_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit a Ticket`)
};

/**
* | output |
* | --- |
* | "Submit a Ticket" |
*
* @param {Settings_Tickets_Create_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_tickets_create_title = /** @type {((inputs?: Settings_Tickets_Create_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Create_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_tickets_create_title(inputs)
});
export { settings_tickets_create_title as "settings.tickets.create_title" }